<template>
    <div class="_content" >
        <!-- 老板店长可见 -->
        <div 
            v-if="this.userRole === '老板' || this.userRole === '店长' "
        >

            <!-- 下拉查询 筛选 -->
            <van-dropdown-menu >

                <!-- 月查询 -->
                <van-dropdown-item 
                    :title-class="this.activeMonth ? 'title_active_color active_blue' : '' " 
                    title="按月查询" ref="item1"
                >
                    <!-- 显示框 -->
                    <div class="month_time">
                        <van-field
                            readonly
                            clickable
                            :value="this.monthStartTime || '开始时间'"
                            input-align="center"
                            :class="startTimePicker === true ? 'time_color' : '' "
                            @click="clickStartTime"
                        />
                        <span>至</span>
                        <van-field
                            readonly
                            clickable
                            input-align="center"
                            :value="this.monthEndTime || '结束时间' "
                            placeholder="结束日期"
                            :class="endTimePicker === true ? 'time_color' : '' "
                            @click="clickEndTime"
                        />
                    </div>

                    <!-- 开始时间 -->
                    <div class="month_time_picker" v-show="this.startTimePicker">
                        <van-datetime-picker
                            :currentDate="this.currentStartTime || ''"
                            type="year-month"
                            title="选择年月"
                            :show-toolbar="false"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :formatter="formatter1"
                            visible-item-count="3"
                            swipe-duration="150"
                        />
                        
                        <div class="month_time_picker_btn">
                            <div @click="cancelStartPicker">取消</div>
                            <div @click="confirmStartPicker">确认</div>
                        </div>
                    </div>

                    <!-- 结束时间 -->
                    <div class="month_time_picker" v-show="this.endTimePicker">
                            <van-datetime-picker
                                :currentDate="this.currentEndTime || ''"
                                type="year-month"
                                title="选择年月"
                                :min-date="minDate"
                                :max-date="maxDate"
                                :show-toolbar="false"
                                :formatter="formatter2"
                                visible-item-count="3"
                                swipe-duration="150"
                            />
                            <div class="month_time_picker_btn">
                            <div @click="cancelEndPicker">取消</div>
                            <div @click="confirmEndPicker">确认</div>
                            </div>
                    </div>
                </van-dropdown-item>

                <!-- 日查询 -->
                <van-dropdown-item 
                    :title-class="this.activeDay ? 'title_active_color active_blue' : '' " 
                    title="按日查询" ref="item2"
                >
                    <!-- 显示框 -->
                    <div class="day_time">
                        <van-field
                            readonly
                            clickable
                            :value="this.dayStartTime || '开始时间'"
                            input-align="center"
                            :class="dayStartTimePicker === true ? 'time_color' : '' "
                            @click="dayClickStartTime"
                        />
                        <span>至</span>
                        <van-field
                            readonly
                            clickable
                            input-align="center"
                            :value="this.dayEndTime || '结束时间' "
                            placeholder="结束日期"
                            :class="dayEndTimePicker === true ? 'time_color' : '' "
                            @click="dayClickEndTime"
                        />
                    </div>

                    <!-- 开始时间 -->
                    <div class="month_time_picker" v-show="this.dayStartTimePicker">
                        <van-datetime-picker
                            :currentDate="this.dayCurrentStartTime || ''"
                            type="date"
                            title="选择年月日"
                            :show-toolbar="false"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :formatter="formatter3"
                            visible-item-count="3"
                            swipe-duration="150"
                        />
                        
                        <div class="month_time_picker_btn">
                            <div @click="dayCancelStartPicker">取消</div>
                            <div @click="dayConfirmStartPicker">确认</div>
                        </div>
                    </div>

                    <!-- 结束时间 -->
                    <div class="month_time_picker" v-show="this.dayEndTimePicker">
                        <van-datetime-picker
                            :currentDate="this.dayCurrentEndTime || ''"
                            type="date"
                            title="选择年月日"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :show-toolbar="false"
                            :formatter="formatter4"
                            visible-item-count="3"
                            swipe-duration="150"
                        />
                        <div class="month_time_picker_btn">
                        <div @click="dayCancelEndPicker">取消</div>
                        <div @click="dayConfirmEndPicker">确认</div>
                        </div>
                    </div>
                </van-dropdown-item>

                <!-- 全部服务查询 -->
                <van-dropdown-item 
                    :title-class="this.activeServe ? 'title_active_color active_blue' : '' "
                    title="服务查询" ref="item3"
                >
                    <div class="service_list">
                        <div 
                            :class="this.tagFlagAll ? 'service_tag service_tag_blue' : 'service_tag'"
                            @click="clickServiceAll"
                        >全部服务</div>
                        
                        <div 
                            v-for="(item, index) in SndServiceData" :key="index"
                            ref="serviceTagList"
                            :secondClassId="item.id"
                            :class="serviceFlag(index) ? 'service_tag service_tag_blue' : 'service_tag' "
                            @click="clickService(index)"
                        >
                            {{item.text}}
                        </div>
                    </div>
                    <div class="month_time_picker_btn">
                        <div @click ="cancelSndService">清空</div>
                        <div @click="confirmSndService">确认</div>
                    </div>
                </van-dropdown-item>

            </van-dropdown-menu>

            <!-- 内容 -->
            <van-cell-group>
                <!-- 总计 -->
                <div class="order_total">
                    <span v-if="this.selectStartTime === null && this.selectEndTime === null">订单合计</span>
                    <span v-else-if="this.selectStartTime !== null && this.selectEndTime !== null">{{this.selectStartTime}} 至 {{this.selectEndTime}}</span>
                    <span>{{this.AllOrderListPage.total}}笔&nbsp;&nbsp;| ￥{{this.AllOrderData.allPrice}}</span>
                </div>
                <!-- 订单列表 -->
                <van-collapse v-model="activeName" accordion>
                        <!-- 不展开的列表 -->
                        <div collapse_list
                            v-for="(item,index) in AllOrderListPageRecords" :key="index"
                            flag="true"
                            @click="getOrderDetailList($event, index)"
                        >
                            <van-collapse-item  
                                :name="index"
                                :value="`${item.total}笔 | ${item.price}￥`"
                                value-class="order_pic"
                                title-class="order_time"
                            >
                                <!-- tag -->
                                <template #title>
                                        <div>{{item.billDate}}
                                                <span>
                                                   <!-- tag -->
                                                </span>
                                        </div>
                                </template>
                                
                                <!-- 展开的详细列表 -->
                                <div class="order_detail bottom-line"  
                                    v-for="(li,index) in orderDetailList" :key="index"
                                    @click.stop="handleClick(tabList[0],index)"
                                >
                                    <div>
                                        
                                        <span>{{li.secondClassName}}</span>
                                        
                                        <span>{{li.createdTime}}
                                            <!-- 未出账 待提交 -->
                                            <van-tag v-if="li.chargeStatus===1 && li.settlementStatus===1" type="primary">未出账</van-tag>

                                            <!-- 已出账 待提交 待结款第一个第二个条件有冲突 用else-if-->
                                            <van-tag v-if="li.chargeStatus===2 && li.settlementStatus===1" type="primary">待结款</van-tag>
                                            
                                            <!-- 已出帐 待审核 已审核 -->
                                            <van-tag v-else-if="li.chargeStatus===2 && (li.settlementStatus===2 || li.paymentStatus===3 || li.paymentStatus===4 || li.paymentStatus===6)" type="primary">待结款</van-tag>

                                            <!-- 已出帐 打款中 打款失败 -->
                                            <van-tag v-else-if="li.chargeStatus===2 && (li.paymentStatus===4 || li.paymentStatus===6)" type="primary">待结款</van-tag>

                                            <!-- 已出帐 已结款 -->
                                            <van-tag v-if="li.chargeStatus===2 && li.paymentStatus===5" type="success">已结款</van-tag>
                                            
                                            <!-- 待审核 已审核 打款中 打款失败 -->
                                            <van-tag v-if="li.chargeStatus===3 && (li.settlementStatus===2 || li.settlementStatus===3 || li.paymentStatus===4 || li.paymentStatus===6)" type="danger">已稽核</van-tag>
                                        
                                        </span>

                                    </div>
                                    <div class="no_settlement" >{{li.orderPrice}}￥<van-icon name="arrow"/></div>
                                </div>

                            </van-collapse-item>

                        </div>

                </van-collapse>

            </van-cell-group>

            <!-- 无搜索结果 错误 -->
            <van-empty v-if="AllOrderListPageRecords&&AllOrderListPageRecords.length === 0 " image="search" description="查询订单无结果" />
            
            <!-- 分页  total总数量 -->
            <van-pagination
                v-if="this.AllOrderListPage.total > 6 "
                v-model="currentPage"
                :total-items="this.AllOrderListPage.total"
                items-per-page="6"
                force-ellipses
                show-page-size="3"
                @change="changePage($event)"
                class="today_pagination"
            />

        </div>

        <!-- 非老板店长 -->
        <van-empty 
            v-else-if=" this.userRole === '员工' || this.userRole === '' " 
            image="error" 
            description="权限不足或网络错误" 
        />
    </div>
</template>
<script>
import config from '@/configs/config'
export default {
    data() {
        return {
            userRole: '', // 权限
            currentPage: 1,
            activeMonth: false,
            activeDay: false,
            activeServe: false,
            // 订单列表
            AllOrderData: {},
            AllOrderListPage: {},
            AllOrderListPageRecords: {},
            // 2级服务列表
            SndServiceData: {},
            // 订单详情列表
            orderDetailList: {},
            // 服务的点击状态
            tagFlagData: [],
            // 筛选发送的2级服务列表
            tagSecondClassId: [],
            tagFlagAll: true,
            // 月
            monthStartTime: '',
            monthEndTime: '',
            // 日
            dayStartTime: '',
            dayEndTime: '',
            // 月
            startTimePicker: true,
            endTimePicker: false,
            // 日
            dayStartTimePicker: true,
            dayEndTimePicker: false,
            // 月 日 时间
            minDate: new Date(2019, 0, 1),
            maxDate: new Date(2050, 10, 1),
            // 月
            currentStartTime: [],
            currentEndTime: [],
            // 日
            dayCurrentStartTime: [],
            dayCurrentEndTime: [],
            // 默认展开栏
            activeName: '',
            // 请求用数据
            shopId: '',
            selectType: true,
            selectStartTime: null,
            selectEndTime: null,
            secondClassId: null,
            // 跳转详情
            tabList: [{
                name: '订单列表详情',
                url: '/pages/orderDetail/index'
            }],
            dataCode: null
        }
    },
    created() {
        this.getAllOrderData()
        this.getSndServiceData()
    },
    methods: {
        async getAllOrderData() {
            // 权限信息
            const roleData = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
            if (roleData && roleData.code === '200') {
                this.shopId = roleData.data.shopId
                this.userRole = roleData.data.role
            } else {
                tuhu.toast(roleData.message || '获取权限信息失败')
            }
            let data = await tuhu.fetch(`${config.apis.GET_ALLORDER_LIST}`, {
                method: 'post',
                body: JSON.stringify({
                    endTime: null,
                    pageNum: 1,
                    pageSize: 6,
                    secondClassId: null,
                    selectType: true,
                    shopId: this.shopId,
                    startingTime: null
                })
            })
            if (data && data.code === '200') {
                this.AllOrderData = data.data
                this.AllOrderListPage = data.data.listPage
                this.AllOrderListPageRecords = data.data.listPage.list
                console.log('全部订单', data.data)
            } else {
				tuhu.toast(data.message || '网络错误')
            }
        },
        // 二级菜单列表
        async getSndServiceData() {

            let data = await tuhu.fetch(`${config.apis.GET_SECOND_CLASS}?level=1`)

            if (data && data.code === '200') {

                this.SndServiceData = data.data

                let length = data.data.length

                for (let i = 0; i < length; i++) {

                    this.tagFlagData.push(false)

                }
                
            } else {

				tuhu.toast(data.message || '网络错误')
                
            }
            
        },
        serviceFlag(i) {
            return this.tagFlagData[i]
        },
        // 月 点击起始时间
        clickStartTime() {
            this.startTimePicker = true
            this.endTimePicker = false
        },
            // 月 点击结束时间
        clickEndTime() {
            this.endTimePicker = true
            this.startTimePicker = false
            this.monthEndTime = `${this.currentEndTime[0]}-${this.currentEndTime[1]}`
        },
         // 日 点击起始时间
        dayClickStartTime() {
            this.dayStartTimePicker = true
            this.dayEndTimePicker = false
        },
            // 日 点击结束时间
        dayClickEndTime() {
            this.dayEndTimePicker = true
            this.dayStartTimePicker = false
            this.dayEndTime = `${this.dayCurrentEndTime[0]}-${this.dayCurrentEndTime[1]}-${this.dayCurrentEndTime[2]}`
        },
        // 按月查询 确认取消 4个按钮
        cancelStartPicker() {
            this.$refs.item1.toggle()
        },
        confirmStartPicker() {
            this.monthStartTime = `${this.currentStartTime[0]}-${this.currentStartTime[1]}`
            this.startTimePicker = false
            this.endTimePicker = true
        },
        cancelEndPicker() {
            this.$refs.item1.toggle()
        },
            // 最后一个选择时间结束 发起请求
        async confirmEndPicker() {
            // 初始
            this.selectStartTime = null
            this.selectEndTime = null
            this.monthEndTime = `${this.currentEndTime[0]}-${this.currentEndTime[1]}`
            this.$refs.item1.toggle()
            // 发送
            this.selectType = true
            this.selectStartTime = this.monthStartTime
            this.selectEndTime = this.monthEndTime
            if (this.selectStartTime !== '' && this.selectEndTime !== null) {
                // 请求
                const data = await tuhu.fetch(`${config.apis.GET_ALLORDER_LIST}`, {
                    method: 'post',
                    body: JSON.stringify({
                        'startingTime': this.selectStartTime,
                        'endTime': this.selectEndTime,
                        'selectType': this.selectType,
                        'shopId': this.shopId,
                        'pageNum': 1,
                        'pageSize': 6,
                        'secondClassId': this.secondClassId
                    })
                })
                if (data && data.code === '200') {
                    this.AllOrderData = data.data
                    this.AllOrderListPage = data.data.listPage
                    this.AllOrderListPageRecords = data.data.listPage.list
                    // 展开全收起
                    this.activeName = ''
                    // 分页跳第一页
                    this.currentPage = 1
                    // 按月查询文本亮
                    this.activeMonth = true
                    // 按日查询文本不亮
                    this.activeDay = false
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            } else {
                tuhu.toast('未选择开始时间')
                this.activeMonth = false
            }
        },
        // 按日查询 确认取消 4个按钮
        dayCancelStartPicker() {
            this.$refs.item2.toggle()
        },
        dayConfirmStartPicker() {
            this.dayStartTime = `${this.dayCurrentStartTime[0]}-${this.dayCurrentStartTime[1]}-${this.dayCurrentStartTime[2]}`
            this.dayStartTimePicker = false
            this.dayEndTimePicker = true
        },
        dayCancelEndPicker() {
            this.$refs.item2.toggle()
        },
            // 最后一个选择时间结束 发起请求
        async dayConfirmEndPicker() {
            // 初始
            this.selectStartTime = null
            this.selectEndTime = null
            this.dayEndTime = `${this.dayCurrentEndTime[0]}-${this.dayCurrentEndTime[1]}-${this.dayCurrentEndTime[2]}`
            this.$refs.item2.toggle()
            // 发送
            this.selectType = false
            this.selectStartTime = this.dayStartTime
            this.selectEndTime = this.dayEndTime
            // 请求
            if (this.selectStartTime !== '' && this.selectEndTime !== null) {
                    const data = await tuhu.fetch(`${config.apis.GET_ALLORDER_LIST}`, {
                    method: 'post',
                    body: JSON.stringify({
                        'startingTime': this.selectStartTime,
                        'endTime': this.selectEndTime,
                        'selectType': this.selectType,
                        'shopId': this.shopId,
                        'pageNum': 1,
                        'pageSize': 6,
                        'secondClassId': this.secondClassId
                    })
                })
                if (data && data.code === '200') {
                    this.AllOrderData = data.data
                    this.AllOrderListPage = data.data.listPage
                    this.AllOrderListPageRecords = data.data.listPage.list
                    // 展开全收起
                    this.activeName = ''
                    // 分页跳第一页
                    this.currentPage = 1
                    // 按月查询文本不亮
                    this.activeMonth = false
                    // 按日查询文本亮
                    this.activeDay = true
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            } else {
                tuhu.toast('未选择开始时间')
                this.activeDay = false
            }
        },
        // 格式化时间显示
            // 按月 开始时间
        formatter1(type, val) {
             if (type === 'year') {
                this.currentStartTime[0] = `${val}`
                return `${val}年`
            } else if (type === 'month') {
                 this.currentStartTime[1] = `${val}`
                return `${val}月`
            }
            return val
        },
            // 按月 结束时间
        formatter2(type, val) {
            if (type === 'year') {
                this.currentEndTime[0] = `${val}`
                return `${val}年`
            } else if (type === 'month') {
                 this.currentEndTime[1] = `${val}`
                return `${val}月`
            }
             return val
        },
            // 按日 开始时间
        formatter3(type, val) {
             if (type === 'year') {
                this.dayCurrentStartTime[0] = `${val}`
                return `${val}年`
            } else if (type === 'month') {
                 this.dayCurrentStartTime[1] = `${val}`
                return `${val}月`
            } else if (type === 'day') {
                this.dayCurrentStartTime[2] = `${val}`
                return `${val}日`
            }
            return val
        },
            // 按日 结束时间
        formatter4(type, val) {
            if (type === 'year') {
                this.dayCurrentEndTime[0] = `${val}`
                return `${val}年`
            } else if (type === 'month') {
                 this.dayCurrentEndTime[1] = `${val}`
                return `${val}月`
            } else if (type === 'day') {
                this.dayCurrentEndTime[2] = `${val}`
                return `${val}日`
            }
             return val
        },
        // 按服务筛选 发送第二服务id
        async confirmSndService() {
            // 勾选服务
            if (this.tagFlagAll) {
                this.tagSecondClassId = []
                let len = this.tagFlagData.length
                for (let i = 0; i < len; i++) {
                    let a = this.$refs.serviceTagList[i].attributes.secondclassid.value
                    let b = parseInt(a)
                    this.tagSecondClassId.push(b)
                }
                this.$refs.item3.toggle()
            } else {
                this.tagSecondClassId = []
                this.tagFlagData.forEach((val, i) => {
                    if (val) {
                        this.tagSecondClassId.push(this.$refs.serviceTagList[i].attributes.secondclassid.value)
                    }
                })
                this.$refs.item3.toggle()
            }
            // 初始
            this.secondClassId = this.tagSecondClassId
            // 请求
            if (this.secondClassId.length !== 0) {
                    const data = await tuhu.fetch(`${config.apis.GET_ALLORDER_LIST}`, {
                    method: 'post',
                    body: JSON.stringify({
                        'startingTime': this.selectStartTime,
                        'endTime': this.selectEndTime,
                        'selectType': this.selectType,
                        'shopId': this.shopId,
                        'pageNum': 1,
                        'pageSize': 6,
                        'secondClassId': this.secondClassId
                    })
                })
                if (data && data.code === '200') {
                    this.AllOrderData = data.data
                    this.AllOrderListPage = data.data.listPage
                    this.AllOrderListPageRecords = data.data.listPage.list
                    // 展开全收起
                    this.activeName = ''
                    // 分页跳第一页
                    this.currentPage = 1
                    // 按服务查询文本亮
                    this.activeServe = true
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            } else {
                tuhu.toast('未选择服务')
                this.secondClassId = null
                this.activeServe = false
            }
            console.log('b', this.secondClassId)
        },
        // 2级服务点击
        clickService(i) {
            this.$set(this.tagFlagData, i, !this.tagFlagData[i])
            this.tagFlagAll = false
        },
            // 全部服务
        clickServiceAll() {
            this.tagFlagAll = !this.tagFlagAll
            let len = this.tagFlagData.length
            if (this.tagFlagAll) {
                for (let i = 0; i < len; i++) {
                    this.tagFlagData[i] = false
                }
            }
        },
            // 清空
        cancelSndService() {
            this.tagFlagAll = false
            let len = this.tagFlagData.length
                for (let i = 0; i < len; i++) {
                    this.$set(this.tagFlagData, i, false)
                }
        },
        // 分页事件
        async changePage(index) {
            const pageNum = index
            let data = await tuhu.fetch(`${config.apis.GET_ALLORDER_LIST}`, {
                method: 'post',
                body: JSON.stringify({
                    'startingTime': this.selectStartTime,
                    'endTime': this.selectEndTime,
                    'selectType': this.selectType,
                    'shopId': this.shopId,
                    'pageNum': pageNum,
                    'pageSize': 6,
                    'secondClassId': this.secondClassId
                })
            })
            if (data && data.code === '200') {
                 this.AllOrderData = data.data
                 this.AllOrderListPage = data.data.listPage
                 this.AllOrderListPageRecords = data.data.listPage.list
                 this.activeName = ''
            } else {
				tuhu.toast(data.message || '网络错误')
            }
        },
        // 详情列表查询
        async getOrderDetailList(e, i) {
            // 当前查询列表时间
            let selectTime = this.AllOrderData.listPage.list[i].billDate
            if (this.activeName !== '') {
                let data = await tuhu.fetch(`${config.apis.GET_ALLORDER_DETAILLIST}`, {
                    method: 'post',
                    body: JSON.stringify({
                        'pageNum': 1,
                        'pageSize': 100000,
                        'secondClassId': this.secondClassId,
                        'selectTime': selectTime,
                        'selectType': this.selectType,
                        // 'selectTime': '2020-06',
                        // 'selectType': true,
                        'shopId': this.shopId
                    })
                })
                if (data && data.code === '200') {
                    this.orderDetailList = data.data.list
                    this.dataCode = 200
                } else {
                    tuhu.toast(data.message || '网络错误')
                    // 展开全收起
                    this.activeName = ''
                }
            } else {
                // 列表收起
            }
        },
        // 跳转
        handleClick (item, index) {
			tuhu.sessionStorage.setItem('shopOrderDetail', JSON.stringify(this.orderDetailList[index]))
            let i = index
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ListInfo: this.orderDetailList[i] || {}
                },
                query: {
                    scsShow: 1
				}
            })
        }
    }
}
</script>
<style lang="less" scoped>
    @themeblue : rgb(55,149,240);
    /deep/.title_active_color.active_blue{
        color: @themeblue;
        >.van-ellipsis{
            color: @themeblue;
        }
    }
    .month_time{
        width: 100%;
        height: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        >span{
            display: flex;
            align-items:center;
        }
    }
    .day_time{
        width: 100%;
        height: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        >span{
            display: flex;
            align-items:center;
        }       
    }
    .month_time_picker_btn{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        >div{
            width: 50%;
            height: 2.3rem;
            font-size:.8rem;
            line-height: 2.3rem;
            text-align: center;
        }
        div:nth-child(1) {
            background: rgb(215,215,215);
        }        
        div:nth-child(2) {
            background: @themeblue;
            color: #fff;
        }
    }
    .time_color{
        /deep/ .van-field__control{
            color: @themeblue;
        }
    }
    .order_total{
        width: 100%;
        height: 2.3rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 .6rem;
        background: rgb(239,239,244);
        >span{
            line-height: 2.3rem;
            font-size: .7rem;
        }
    }
    .order_detail{
        width: 100%;
        height: 3.3rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: .5rem .6rem .5rem 0;
        font-size: .7rem;
        div:nth-child(1) {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
        div:nth-child(2) {
            line-height: 2.3rem;
            text-align: center;
            display: table;
            .van-icon{
                display: table-cell;
                vertical-align: middle;
            }
        }
    }
    .service_list{
        display: flex;
        flex-direction: row;
        flex-wrap:wrap;
        padding: .5rem 0 .5rem .65rem;
        .service_tag{
        width: 5.5rem;
        height: 1.75rem;
        line-height: 1.75rem;
        text-align: center;
        border-radius: .1rem;
        margin: 0 .4rem .4rem 0;
        }
        .service_tag.service_tag_blue{
        background: @themeblue;
        color: #fff;
        }
    }
    /deep/.order_pic{
        >span{
            color: #000;
        }
    }
    /deep/.order_time{
        >div{
            color:@themeblue
        }
    }
    .no_settlement{
        font-size: .7rem;
        color: rgb(1,156,98);
    }
</style>


// WEBPACK FOOTER //
// src/pages/orderAll/index.vue